import { PLANS_GTM_EVENTS } from "../../constants/Plans";
import { getProductCode, hasGtmEnabled } from "../../helpers/AppHelper";

window.dataLayer = window.dataLayer || [];

const labels = {
	wv_k12_12m: "hWwNCOvc42cQzLGQuAM",
	wv_bizoct17_1m: "QS4KCKWpp3kQzLGQuAM",
	wv_bizoct17_12m: "WsIvCK_avnkQzLGQuAM",
	wv_bizindiv_12m: "4hi6CM21iH8QzLGQuAM",
	wv_bizindiv_1m: "4pvWCOmkm38QzLGQuAM",
	default: "rekkCK-F0GcQzLGQuAM", // If product isn't in dict
};

class TagManagerTrack {
	static registerPurchase = (
		isUpgrade,
		newProductCode,
		newProductName,
		oldProductCode,
		orderId,
		price
	) => {
		if (hasGtmEnabled() === false) {
			return false;
		}
		window.dataLayer.push({
			event: "PaymentCompleted",
			"Subscription-Price": price,
			"Order-ID": orderId,
		});

		var label = labels[newProductCode] ? labels[newProductCode] : labels["default"];

		window.dataLayer.push({
			"Subscription-Product-Code": newProductCode,
			"Subscription-Price": price,
			"Order-ID": orderId,
			"Adwords-Label": label,
			transactionId: orderId,
			transactionTotal: price,
			transactionProducts: [
				{
					sku: newProductCode,
					name: newProductCode,
					price: price,
					quantity: 1,
				},
			],
			event: "ecommerce_event",
		});

		window.dataLayer.push({
			event: "purchase",
			orderId: "I_" + orderId,
			orderTotal: price,
			productName: newProductName,
			productId: newProductCode,
			productPrice: price,
		});

		/* Added for GTM-2 */
		if (isUpgrade) {
			window.dataLayer.push({
				event: "planUpgrade",
				newPlan: newProductCode,
				formerPlan: oldProductCode,
				planCategory: newProductCode.indexOf("k12") > 0 ? "education" : "personal",
			});
		}

		if (PLANS_GTM_EVENTS.hasOwnProperty(newProductCode)) {
			window.dataLayer.push({
				event: PLANS_GTM_EVENTS[newProductCode],
			});
		}
	};

	static onTrialAccountActivated = productCode => {
		if (hasGtmEnabled() === false) {
			return false;
		}
		if (typeof productCode === "undefined" || productCode === null) {
			productCode = getProductCode();
		}
		window.dataLayer.push({
			event: "Website Conversion",
			category: "Website Conversion",
			action: "Start Trial",
			label: productCode,
		});
		if (PLANS_GTM_EVENTS.hasOwnProperty(productCode)) {
			window.dataLayer.push({
				event: PLANS_GTM_EVENTS[productCode],
			});
		}
	};

	static onAccountActivated = productCode => {
		if (hasGtmEnabled() === false) {
			return false;
		}
		if (typeof productCode === "undefined" || productCode === null || productCode === "") {
			productCode = getProductCode();
		}
		window.dataLayer.push({
			event: "Website Conversion",
			category: "Website Conversion",
			action: "Signup",
			label: productCode,
		});
	};

	static trackABTestStartToDataLayer = (eventName, properties) => {
		if (hasGtmEnabled() === false) {
			return false;
		}
		if (
			typeof properties !== "undefined" &&
			properties.hasOwnProperty("testName") &&
			properties.hasOwnProperty("eventVariation")
		) {
			window.dataLayer.push({
				abtest: "variation1",
			});
		}
	};

	static sendABCustomDimension = (dimension, value) => {
		if (hasGtmEnabled() === false) {
			return false;
		}
		let obj = {};
		obj[dimension] = value;
		window.dataLayer.push(obj);
	};

	static trackCartPageView = () => {
		if (hasGtmEnabled() === false) {
			return false;
		}
		window.dataLayer.push({
			event: "cart_page_view",
		});
	};

	static trackFreeAccountSignup = () => {
		if (hasGtmEnabled() === false) {
			return false;
		}
		window.dataLayer.push({
			event: "personal_free_plan_signup",
		});
	};
}

export default TagManagerTrack;
